import { Mail, MailX } from 'lucide-react'
import { useState } from 'react'
import { useNotification } from '../contexts/NotificationContext'
import { setGroupEmailOptOut } from '../services/groupService'
import { Button } from './ui/button'

// A member's switch for this group's owner emails. The Stop link in an email
// writes the same opt-out, so this is also how someone turns it back on.
export default function GroupEmailToggle({ groupId, optedOut, onChange }) {
  const notify = useNotification()
  const [busy, setBusy] = useState(false)

  const toggle = async () => {
    setBusy(true)
    try {
      await setGroupEmailOptOut({ groupId, optOut: !optedOut })
      notify.success(optedOut ? 'Group emails are back on' : "You won't get emails from this group")
      onChange?.(!optedOut)
    } catch (err) {
      console.error('Error updating group email:', err)
      notify.error(err.message || 'Failed to update')
    } finally {
      setBusy(false)
    }
  }

  return (
    <Button variant="ghost" size="sm" onClick={toggle} disabled={busy} className="h-7 px-2 text-xs text-muted-foreground">
      {optedOut ? <MailX className="h-3.5 w-3.5 mr-1" /> : <Mail className="h-3.5 w-3.5 mr-1" />}
      {optedOut ? 'Group emails off' : 'Group emails on'}
    </Button>
  )
}
